<template>
  <div class="d-flex ga-4 align-center" :style="`min-height: ${height}`" :class="{ 'pr-2': $slots.append, 'pr-4': !$slots.append }">
    <v-list-item :prepend-icon="icon" class="px-0" slim>
      <template #title>
        <span class="font-weight-medium">
          <slot name="title">{{ title }}</slot>
        </span>
      </template>

      <template #subtitle>
        <slot name="subtitle">{{ subtitle }}</slot>
      </template>
    </v-list-item>

    <v-divider />

    <slot name="append" />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    height?: string
    icon?: string
    title?: string
    subtitle?: string
  }>(),
  {
    height: "48px",
    title: undefined,
    icon: undefined,
    subtitle: undefined,
  },
)
const { title, subtitle, icon, height } = toRefs(props)
</script>
